import styled, { css } from 'styled-components';
import { greenColor, lightGrey3Color } from 'js/config/style';

const activeStyle = css`
  background: ${greenColor};
  color: white;
  font-weight: 500;

  &:hover {
    background: ${greenColor.darken(0.5)};
  }
  &:active {
    background: ${greenColor.darken(1)};
    box-shadow: 0 1px 3px -1px black inset;
  }
`;

const disabledStyle = css`
  background: ${lightGrey3Color};
  color: white;
  font-weight: 500;

  &:hover {
    background: ${lightGrey3Color.darken(0.5)};
  }
  &:active {
    background: ${lightGrey3Color.darken(1)};
    box-shadow: 0 1px 3px -1px black inset;
  }
`;

export default styled.div`
  ${({ active }) => (active ? activeStyle : disabledStyle)};
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.8rem;
  cursor: pointer;
  user-select: none;
`;
